import { render, staticRenderFns } from "./BindERC20.vue?vue&type=template&id=4959b022&scoped=true&"
import script from "./BindERC20.vue?vue&type=script&lang=js&"
export * from "./BindERC20.vue?vue&type=script&lang=js&"
import style0 from "./BindERC20.vue?vue&type=style&index=0&id=4959b022&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4959b022",
  null
  
)

export default component.exports